import './PricingDisclosure.css'

export const PricingDisclosure = () => (<div id='pricing-disclosure'>
    <p>Cleaning rates vary. Contact us today to schedule a free, brief cleaning consultation at your earliest convenience!</p>
</div>)